import { useEffect } from 'react';

import useTranslation from '../../customHooks/translate';
import { useAnimateOnView } from '../../customHooks/useAnimateOnView';
import { landingFeatures } from 'landingFeatures';

import { fadeInUp } from './landing-motion';

const Features = () => {
  const translation = useTranslation();
  const { ref, visible } = useAnimateOnView();

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('user') || '{}');
    if (userInfo) {
      window.location.href = '/dashboard';
    }
  }, []);

  return (
    <section
      ref={ref}
      id="features"
      className="mt-[48px] flex flex-col gap-[32px] px-[16px] md:mt-[72px] md:px-[56px] lg:mt-[280px]"
    >
      <p
        className={`m-auto max-w-[700px] text-center text-[32px] font-bold md:text-[40px] ${
          visible ? fadeInUp : 'opacity-0'
        }`}
        style={{ animationDelay: visible ? '0.04s' : undefined }}
      >
        {translation.home.SolutionsParagraph.SolutionParagraphText}
      </p>
      <div className="grid grid-cols-1 gap-[12px] rounded-[12px] bg-[rgba(247,249,252,1)] p-[16px] md:p-[32px] xl:grid-cols-2">
        {landingFeatures(translation)?.map((feature, index, arr) => {
          const isLast = index === arr.length - 1;

          return (
            <div
              className={`group flex flex-col items-center gap-[24px] rounded-[8px] bg-white p-[20px] transition-all duration-300 hover:-translate-y-[3px] hover:shadow-[0_12px_24px_rgba(41,45,50,0.12)] md:flex-row md:p-[32px] ${
                isLast ? 'xl:col-span-2' : ''
              } ${visible ? fadeInUp : 'opacity-0'}`}
              style={{
                animationDelay: visible ? `${0.08 + index * 0.07}s` : undefined,
              }}
              key={feature?.title}
            >
              <img
                className="h-[120px] w-[120px] transition-transform duration-300 group-hover:scale-[1.03]"
                src={feature?.img}
                alt={feature?.title}
              />
              <div className="flex flex-col gap-[16px]">
                <p className="text-[24px] font-bold">{feature.title}</p>
                <p className="max-w-[450px] text-[16px] font-normal">
                  {feature.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Features;
